"use client";
import { Button } from "@/components/ui/button";
import { fetchRandomVideos } from "@/lib/actions/videos/fetchRandomVideos";
import React, { useEffect } from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Play } from "lucide-react";
import { useRouter } from "next/navigation";
import useDeviceType from "@/lib/hooks/useDeviceType";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DialogDescription } from "@radix-ui/react-dialog";

const Feed = () => {
  const router = useRouter();
  const [trending, setTrending] = React.useState<Post[]>([]);
  const { isIOS } = useDeviceType();
  useEffect(() => {
    try {
      const handleGet = async () => {
        const data = await fetchRandomVideos();
        if (data.success === false) {
          console.warn(data.message);
        }
        setTrending(data);
      };
      handleGet();
    } catch (error) {
      console.error("Error fetching trending videos ", error);
    }
  }, []);
  return (
    <div className="gap-8">
      <div className="flex justify-end items-end">
        <Button
          variant="ghost"
          onClick={() => {
            router.push("/videos");
          }}
          aria-label="View more"
        >
          <p className="text-xs text-bl-8">View more</p>
        </Button>
      </div>
      <ScrollArea className="w-[calc(100vw-1rem)] whitespace-nowrap">
        <div className="flex w-max gap-4 p-2 px-4 sm:px-20">
          {trending && trending.length > 0 && trending.map((item) => (
            <Dialog key={item.id}>
              <DialogTrigger className="h-[26rem] w-[16rem] relative rounded-lg" aria-label="open video">
                <video
                  src={item.video}
                  className="h-[26rem] w-[16rem] object-cover rounded-lg"
                  playsInline
                  autoPlay={isIOS ? true : false}
                />
                <div>
                  <Play className="h-8 w-8 fill-zinc-50 text-zinc-50  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                </div>
              </DialogTrigger>
              <DialogContent>
                <DialogTitle>{item.title}</DialogTitle>
                <div className="flex w-full gap-4 p-2 justify-center items-center">
                  <video
                    src={item.video}
                    className="h-[30rem] w-[20rem] object-fit rounded-lg"
                    playsInline
                    autoPlay={true}
                  />
                </div>
                <DialogDescription>
                  {item.description}
                </DialogDescription>
              </DialogContent>
            </Dialog>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
      <div className="flex gap-4 p-2 flex-wrap"></div>
    </div>
  );
};

export default Feed;
